import React from "react";
import VectorShape11 from "../assets/images/shape/vector-shape11.png";
import Partner4 from "../assets/images/logo/gsch1.jpg";
import Partner5 from "../assets/images/logo/gsch2.jpg";
import Partner6 from "../assets/images/logo/gsch3.png";
import Loadable from "@loadable/component";
import { fontsName } from "../assets/fonts/fontsName";
import { request, gql } from "graphql-request";
import GalleryModal from "./GalleryModal";
import { REQUEST_URL } from "./RequestUrl";
const OwlCarousel = Loadable(() => import("react-owl-carousel3"));

const options = {
  loop: true,
  nav: true,
  dots: false,
  autoplayHoverPause: true,
  autoplay: true,
  margin: 30,
  navText: [
    "<i class='flaticon-left-1'></i>",
    "<i class='flaticon-right-1'></i>",
  ],
  responsive: {
    0: {
      items: 1,
    },
    768: {
      items: 3,
    },
    992: {
      items: 3,
    },
  },
};

const GALLERY_IMAGES = gql`
  {
    getAllWebsiteGallery {
      _id
      title
      pictureLinks
    }
  }
`;

const Gallery = () => {
  const [display, setDisplay] = React.useState(false);
  const [isOpen, setIsOpen] = React.useState(false);
  const [imagesGallery, setImagesGallery] = React.useState([]);
  const [imagesInfo, setImagesInfo] = React.useState({});

  React.useEffect(() => {
    request(REQUEST_URL, GALLERY_IMAGES).then((data) => {
      if (data.getAllWebsiteGallery !== null) {
        setImagesGallery(data.getAllWebsiteGallery);
        console.log("getAllWebsiteGallery:", data.getAllWebsiteGallery);
      }
    });
  }, []);

  React.useEffect(() => {
    if (imagesGallery) {
      console.log("imagesGallery:", imagesGallery);
    }
  }, [imagesGallery]);

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  React.useEffect(() => {
    setDisplay(true);
  }, []);
  return (
    <>
      <section className="industries-serve-area bg-fafafb pt-100 pb-70">
        <div className="container">
          <div className="section-title">
            <h2 style={{ fontFamily: fontsName.Vazir, color: "#6200EA" }}>
              گالری تصاویر
            </h2>
            <p
              style={{
                width: "25%",
                height: "4px",
                backgroundColor: "#FFFF00",
                marginTop: "20px",
              }}
            ></p>
          </div>
          {/* <div style={{ textAlign: "center" }}>
          
        </div> */}
          {/* <div className="row">
          <div className="col-lg-4 col-md-12"> */}
          {display ? (
            <OwlCarousel
              className="testimonials-slides  owl-carousel owl-theme"
              {...options}
            >
              {imagesGallery && imagesGallery.length > 0
                ? imagesGallery.map((item, index) => (
                    <div
                      style={{
                        cursor: "pointer",
                        height: "300px",
                        width: "100%",
                        position: "relative",
                      }}
                    >
                      <img
                        key={index}
                        src={item.pictureLinks[0]}
                        // className="middle"
                        alt="gallery"
                        onClick={() => {
                          setImagesInfo({});
                          handleOpen();
                          setImagesInfo(item);
                        }}
                        style={{
                          height: "100%",
                          width: "100%",
                        }}
                      />
                      <div
                        style={{
                          width: "100%",
                          position: "absolute",
                          bottom: 0,
                          zIndex: "5",
                          backgroundColor: "#e1e1e1",
                          opacity: "0.6",
                          padding: "10px 0px",
                        }}
                      >
                        <p
                          style={{
                            fontFamily: fontsName.Vazir,
                            color: "#444",
                            textAlign: "center",
                            fontSize: "16px",
                          }}
                        >
                          {item.title}
                        </p>
                      </div>
                    </div>
                  ))
                : ""}

              {/* <img
                src={Partner5}
                className="middle"
                alt="Partner"
                onClick={handleOpen}
                style={{ cursor: "pointer" }}
              />
              <img
                src={Partner6}
                className="middle"
                alt="Partner"
                onClick={handleOpen}
                style={{ cursor: "pointer" }}
              />

              <img
                src={Partner4}
                className="middle"
                alt="Partner"
                onClick={handleOpen}
                style={{ cursor: "pointer" }}
              />
              <img
                src={Partner5}
                className="middle"
                alt="Partner"
                onClick={handleOpen}
                style={{ cursor: "pointer" }}
              />
              <img
                src={Partner6}
                className="middle"
                alt="Partner"
                onClick={handleOpen}
                style={{ cursor: "pointer" }}
              />
              <img
                src={Partner4}
                className="middle"
                alt="Partner"
                onClick={handleOpen}
                style={{ cursor: "pointer" }}
              /> */}
            </OwlCarousel>
          ) : (
            ""
          )}
          {/* </div>
        </div> */}
        </div>
        <div className="vector-shape11">
          <img src={VectorShape11} alt="Vector Shape" />
        </div>
      </section>
      <GalleryModal
        open={isOpen}
        onClose={handleClose}
        imagesInfo={imagesInfo}
      />
    </>
  );
};

export default Gallery;
